import { Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EventService } from '../../services/event.service';
import { TourService } from '../../services/tour.service';
import { ToolbarService } from '../../services/toolbar.service';
import { ConfigService } from '../../services/config.service';
import { AError } from '../../models/aerror';
import { AppUrls } from '../../app.urls';

@Component({
  selector: 'app-startup',
  templateUrl: './startup.component.html',
  styleUrls: ['./startup.component.scss']
})
export class StartupComponent implements OnInit {

  // set class on host element
  @HostBinding('class') classes = 'app-content';

  // User & error messages are translations keys that will be translated by the view
  public userMessage = 'startup.general';
  public errorMessage: string;
  public error: AError;

  constructor(
    private router: Router,
    private events: EventService,
    private tour: TourService,
    private toolbar: ToolbarService,
    private config: ConfigService
  ) {
  }

  ngOnInit(): void {
    this.userMessage = 'startup.general';
    this.error = undefined;
    this.errorMessage = undefined;

    this.toolbar.setToolbarConfig({
      backAction: undefined,
      showRefresh: false,
      showSettings: false,
      showCall: true,
      showLogout: false
    });
    if (this.checkAndPropagateSettings()) {
      this.restoreTour().then(() => this.goToHome());
    }
  }

  // ===== Public getters ===== //

  public get hasError(): boolean {
    return !!this.error || (this.errorMessage && this.errorMessage.length > 0);
  }

  public get translateableMessage(): string {
    return this.hasError ? this.errorMessage : this.userMessage;
  }

  // ===== Private helpers ===== //

  private restoreTour(): Promise<void> {
    this.userMessage = 'startup.restoringTour';
    return this.tour.restore();
  }

  private checkAndPropagateSettings(): boolean {
    this.userMessage = 'startup.checkingSettings';
    const phoneNumber = this.config.getPhoneNumber();
    if (phoneNumber) {
      this.events.phoneNumberChanged.next(phoneNumber);
      return true;
    } else {
      this.goToSettings();
      return false;
    }
  }

  private goToHome(): void {
    this.router.navigate([AppUrls.ROOT, AppUrls.Home], { replaceUrl: true });
  }

  private goToSettings(): void {
    this.router.navigate([AppUrls.ROOT, AppUrls.Settings]);
  }

  private fatalError(someError: any): void {
    this.userMessage = '';
    this.error = someError;
  }
}
